"use client";
import { jsx as a } from "react/jsx-runtime";
import { cva as l } from "class-variance-authority";
import { forwardRef as n } from "react";
import { cn as c } from "./index22.mjs";
const d = l(
  `
    block
    w-full
    rounded-md
    border
    transition-colors
    placeholder:transition-colors
    focus:outline-none
    disabled:cursor-not-allowed
    disabled:opacity-60
    `,
  {
    variants: {
      tone: {
        dark: "bg-gray-925 text-white placeholder:text-gray-400 border-gray-700 focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900 shadow-[0_1px_1.5px_rgba(255,255,255,0.07)]",
        light: "bg-white text-gray-900 placeholder:text-gray-500 border-gray-300 focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-white"
      },
      size: {
        sm: "text-sm leading-5 px-3 py-2 min-h-20 min-w-64",
        md: "text-base leading-6 px-4 py-3 min-h-24 min-w-72",
        lg: "text-base leading-6 px-4 py-4 min-h-32 min-w-80"
      },
      resize: {
        vertical: "resize-y",
        horizontal: "resize-x",
        all: "resize",
        none: "resize-none"
      }
    },
    defaultVariants: {
      tone: "light",
      size: "md",
      resize: "vertical"
    }
  }
), f = n(
  ({ className: e, size: i = "md", tone: r = "light", resize: t = "vertical", ...s }, o) => /* @__PURE__ */ a("textarea", { ref: o, className: c(d({ size: i, tone: r, resize: t }), e), ...s })
);
f.displayName = "TextAreaInput";
export {
  f as TextAreaInput
};
